"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("../Button"));
function HasError(_a) {
    var btnText = _a.btnText, title = _a.title, btnHandler = _a.btnHandler;
    return (react_1.default.createElement("div", { className: "lead has-error error-container" },
        react_1.default.createElement("h2", null, title),
        react_1.default.createElement(Button_1.default, { text: btnText, onClick: function () { return btnHandler(); } })));
}
exports.default = HasError;
